import ArrowLeftIcon from "@/common/images/icons/arrow-left.svg?react";
import { useAppStore } from "@/common/store/appStore";
import { mainBus } from "@/common/buses";
import { useCallback } from "react";
import "./FullScreenNav.scss";

interface IFullScreenNav {
  gifId: string;
}

export const FullScreenNav = ({ gifId }: IFullScreenNav) => {
  const isFullScreen = useAppStore((state) => state.isFullScreen);

  const handleToggleFullScreen = useCallback(() => {
    mainBus.emit("toggle_fullscreen", { id: gifId });
  }, [gifId]);

  if (!isFullScreen) {
    return null;
  }

  return (
    <div className="fullScreenNavWrap">
      <button className="backButton" onClick={handleToggleFullScreen}>
        <ArrowLeftIcon />
      </button>
    </div>
  );
};
